"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CumPerfRow = _interopRequireDefault(require("./CumPerfRow"));

require("./PerformanceTable.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CumPerfTable =
/*#__PURE__*/
function (_Component) {
  _inherits(CumPerfTable, _Component);

  function CumPerfTable(props) {
    var _this;

    _classCallCheck(this, CumPerfTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CumPerfTable).call(this, props));
    _this.state = {
      i18n: _this.props.translationDictionary
    };
    return _this;
  }

  _createClass(CumPerfTable, [{
    key: "renderRows",
    // create the rows
    value: function renderRows() {
      var _this2 = this;

      return this.props.data.map(function (fund, index) {
        return _react.default.createElement(_CumPerfRow.default, {
          key: index,
          fund: fund,
          index: index,
          showCommonPeriod: _this2.props.showCommonPeriod,
          isPortfolio: _this2.props.isPortfolio
        });
      });
    } // create the header

  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var i18n = this.state.i18n;
      var _this$props = this.props,
          data = _this$props.data,
          showCommonPeriod = _this$props.showCommonPeriod,
          commonPeriodStart = _this$props.commonPeriodStart,
          commonPeriodEnd = _this$props.commonPeriodEnd,
          isPortfolio = _this$props.isPortfolio;
      var stdPerformance = Array.isArray(data[0].stdPerformance) ? data[0].stdPerformance[0] : data[0].stdPerformance;
      var asOfDate = new Date(stdPerformance.asOfDate).toLocaleDateString();
      var commonStartDate = commonPeriodStart ? new Date(commonPeriodStart).toLocaleDateString() : new Date(stdPerformance.commonPeriodNAVStart).toLocaleDateString();
      var commonEndDate = commonPeriodEnd ? new Date(commonPeriodEnd).toLocaleDateString() : new Date(stdPerformance.commonPeriodNAVEnd).toLocaleDateString();
      return _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement("th", {
        colSpan: !isPortfolio ? "2" : "1",
        scope: "colgroup",
        className: "textLeft"
      }, i18n.t('as of'), " ", asOfDate), _react.default.createElement("th", {
        colSpan: "3",
        scope: "colgroup",
        className: "borderleft borderbottom textCenter"
      }, i18n.t('Cumulative Returns')), _react.default.createElement("th", {
        colSpan: showCommonPeriod ? "6" : "5",
        scope: "colgroup",
        className: "borderleft borderbottom textCenter"
      }, i18n.t('Average Annual Total Returns'))), _react.default.createElement("tr", null, !isPortfolio ? _react.default.createElement("th", {
        scope: "col",
        className: "textLeft"
      }, i18n.t('Ticker')) : null, _react.default.createElement("th", {
        scope: "col",
        className: "textLeft"
      }, isPortfolio ? i18n.t('name') : i18n.t('Fund')), _react.default.createElement("th", {
        scope: "col",
        className: "borderleft textCenter"
      }, i18n.t('1-Month')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter"
      }, i18n.t('3-Month')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter"
      }, i18n.t('YTD')), _react.default.createElement("th", {
        scope: "col",
        className: "borderleft textCenter"
      }, i18n.t('1-Year')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter"
      }, i18n.t('3-Year')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter"
      }, i18n.t('5-Year')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter"
      }, i18n.t('10-Year')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter"
      }, i18n.t('Since'), " ", _react.default.createElement("br", null), i18n.t('Inception')), showCommonPeriod ? _react.default.createElement("th", {
        scope: "col",
        className: "textCenter"
      }, i18n.t('Common Period'), _react.default.createElement("br", null), " ", commonStartDate, " - ", commonEndDate, "  ") : null));
    }
  }, {
    key: "render",
    value: function render() {
      var i18n = this.state.i18n;
      var showTitle = this.props.showTitle;
      return _react.default.createElement("div", {
        className: "perf-table-container"
      }, showTitle ? _react.default.createElement("div", {
        className: "heading"
      }, i18n.t('Standardized Performance')) : null, _react.default.createElement("table", {
        className: "table"
      }, this.renderHeader(), _react.default.createElement("tbody", null, this.renderRows())), _react.default.createElement("br", null), _react.default.createElement("br", null));
    }
  }]);

  return CumPerfTable;
}(_react.Component);

_defineProperty(CumPerfTable, "defaultProps", {
  data: null,
  translationDictionary: null,
  showTitle: true,
  showCommonPeriod: true,
  isPortfolio: false
});

CumPerfTable.propTypes = {
  /**
   * Fund data to be used for Performance. Should be array of funds
   */
  data: _propTypes.default.array.isRequired,

  /**
   * Translation dictionary (i18) - needed for tables
   */
  translationDictionary: _propTypes.default.object.isRequired,

  /**
  * Show the title or not
  */
  showTitle: _propTypes.default.bool,

  /**
   * Show the common period returns
   */
  showCommonPeriod: _propTypes.default.bool,

  /**
   * Get the commone period start
   */
  commonPeriodStart: _propTypes.default.string,

  /**
   * Get the commone period end
   */
  commonPeriodEnd: _propTypes.default.string,

  /**
   * Indicate if the table is portfolio level
   */
  isPortfolio: _propTypes.default.bool
};
var _default = CumPerfTable;
exports.default = _default;